export default __webpack_public_path__ + "static/IMG_5532-6b657e83a247c7e2536259e3811b4d68.jpeg";